import type { TypedDocumentNode } from '@apollo/client';
import { gql, useMutation } from '@apollo/client';
import { useLayoutEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import { useAbsoluteURL } from 'hooks/useAbsoluteURL';

import type {
  VisitCampaignPage,
  VisitCampaignPageVariables,
} from './__generated__/index.graphql';

const VISIT_CAMPAIGN_PAGE = gql`
  mutation VisitCampaignPage($url: String!) {
    visitCampaignPage(input: { url: $url }) {
      errors {
        message
      }
    }
  }
` as TypedDocumentNode<VisitCampaignPage, VisitCampaignPageVariables>;

export const ReportCampaignVisit = () => {
  const [searchParams] = useSearchParams();
  const [visitCampaignPage] = useMutation(VISIT_CAMPAIGN_PAGE);
  const location = useLocation();
  const href = useAbsoluteURL(location, { stripBaseName: true });

  useLayoutEffect(() => {
    if (!searchParams.get('utm_campaign')) {
      return;
    }
    visitCampaignPage({ variables: { url: href } });
  }, [searchParams, visitCampaignPage, href]);

  return null;
};
